
import Vue from  'vue'
import BgHome from './BgHome.js'
import {getBounds} from '../../utils/dom/pos.js';
import TEXT from './text.js'

/*function easeOutExpo (t, b, c, d)
{
    return (t == d) ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b
}*/

function easeOutCirc(t, b, c, d)
{
    return c * Math.sqrt(1 - (t=t/d-1)*t) + b
}

export default {

    data()
    {
        return {
            fakeScroll: !this.$root.$children[0].support.touch,
            subtitleY: 0,
            textWidth: 'none',
            margLeft: '0',
            video: !this.$root.$children[0].support.touch, //!IS_MOBILE
            mark: -1,
            isScrolling: true
        }
    },

    props: {
        focus: { type: Boolean, default: true }
    },

    created()
    {
        // EVENTS
        this.eventHub.$on('window:resized', this._onResize)

        if (this.fakeScroll)
        {
            this.$root.$children[0].scroll.addOnSmoothScroll(this._onScroll)
        }
        else
        {
            this.$root.$children[0].scroll.addOnScroll(this._onScroll)
        }

        this.eventHub.$on('enterFrame', this._enterFrame)

        // TEXT (CONTENT)
        this.textContent = this._getText()

    },

    mounted()
    {
        const [winW, winH] = this.$root.$children[0].windowSize
        const canvasElmt = this.$el.querySelector('#home-webgl-bg')


        // CREATE BACKGROUND 3D
        const bg = new BgHome( canvasElmt, winW, winH, this.video, this._onBgLoaded.bind( this ), this.$root.$children[0].support.touch )
        this._bg = bg


        // INIT SCROLL DATAS
        this._scrollY = 0
        this._scrollBg = 0
        this._scrollDown = true
        // this._time = 0


        // TEXT
        if (this.fakeScroll)
        {
            this._lineListElmt = [...this.$el.querySelectorAll('.c-text-line')]
            this._initText()
        }
        else
        {
            this._lineChildListElmt = [...this.$el.querySelectorAll('.c-text-line>*')]
            this.$root.$children[0].setHeight(-1)

            const textWidth = this._getTextWidth()
            this.textWidth = textWidth + 'px'
            this.margLeft = this._getTextMarg( textWidth )
        }


        // SEE TEXT
        clearTimeout(this._scrollingTo)
        this._scrollingTo = setTimeout(this._onUnscroll.bind(this), 1500)


        this._initMarks()
    },

    destroyed()
    {
        if (this._bg)
        {
            this._bg.dispose()
        }
        this.eventHub.$off('window:resized', this._onResize)
        this.eventHub.$off('enterFrame', this._enterFrame)

        if (this.fakeScroll)
        {
            this.$root.$children[0].scroll.removeOnSmoothScroll(this._onScroll)
        }
        else
        {
            this.$root.$children[0].scroll.removeOnScroll(this._onScroll)
        }


        clearTimeout(this._scrollingTo)
    },

    methods: {

        _checkMarks()
        {
            if (!this._marksLimits)
            {
                this._initMarks()
            }

            const y = this._scrollY + this.$root.$children[0].windowSize[1] * 0.5
            const m = this.mark

            for (const limits of this._marksLimits)
            {
                if (limits.top < y && limits.bottom > y)
                {
                    if (limits.id !== m)
                    {
                        this.mark = limits.id
                    }
                    return
                }
            }

            if (m !== -1)
            {
                this.mark = -1
            }
        },

        _initMarks()
        {
            if (!this._marksIn)
            {
                this._marksIn = [...this.$el.querySelectorAll('.js-home-mark-in')]
            }

            if (!this._marksOut)
            {
                this._marksOut = [...this.$el.querySelectorAll('.js-home-mark-out')]
            }

            if (!this._marksLimits)
            {
                this._marksLimits = []
            }

            const mIn = this._marksIn
            const mOu = this._marksOut
            const mLi = this._marksLimits
            const y = this._scrollY

            for (let i = 0; i < this._marksIn.length; i++)
            {
                const bot = getBounds(mOu[i])
                mLi[i] = {
                    id: i,
                    top: getBounds(mIn[i]).y - y,
                    bottom: bot.y + bot.h - y
                }
            }
        },


        /*
                ┌─────────────────────────────────────────────
                │
                │       INIT TEXT
                │
                └─────────────────────────────────────────────
        */

        _onResize( w, h )
        {
            if (this._bg)
            {
                this._bg.resize(w, h)
            }

            if (this.fakeScroll)
            {
                this._initText(true)
            }
            else
            {
                const textWidth = this._getTextWidth()
                this.textWidth = textWidth + 'px'
                this.margLeft = this._getTextMarg( textWidth )
            }

            this._initMarks()
        },

        _enterFrame( dt )
        {
            const bg = this._bg

            if (this.focus)
            {
                if (this.fakeScroll)
                {
                    this._updateTiling(dt)
                }

                if (bg)
                {
                    bg.scrollVelocity = this.fakeScroll ? this.$root.$children[0].scroll.smoothVelocity : this.$root.$children[0].scroll.delayedVelocity
                    bg.update(dt)
                }
            }
        },

        _onBgLoaded()
        {
            this.eventHub.$emit('page:loaded', this)
            this._bg.scroll( this._scrollBg )
        },

        _onScroll( scrollY )
        {
            const maxScroll = this.$root.$children[0].height - this.$root.$children[0].windowSize[1]
            const elmtsToChange = []
            const bg = this._bg


            // TILE HIDDEN (PERFORMANCES)
            if (this.fakeScroll)
            {
                this._setLineTiling( Math.round(scrollY) )
            }


            // 3D BACKGROUND
            if (bg)
            {
                const scrollBg = scrollY / maxScroll
                bg.scroll( scrollBg )
            }
            else
            {
                this._scrollBg = scrollY / maxScroll
            }


            // UNSCROLLING
            if (!this.isScrolling)
            {
                if (Math.abs(this.$root.$children[0].scroll.smoothVelocity) > 0.75)
                {
                    this.isScrolling = true
                    // this.$el.classList.remove('is-unscroll')
                    // this.$el.classList.add('is-scroll')
                }

                clearTimeout(this._scrollingTo)
                this._scrollingTo = setTimeout(this._onUnscroll.bind(this), 1500)
            }


            // SUBTITLE (GOLD)
            this.subtitleY = -(this.$root.$children[0].windowSize[1] * 0.5 * (scrollY / maxScroll - 0.5)).toFixed(1)



            this._scrollDown = (this._scrollY < scrollY) ? true : false
            this._scrollY = scrollY
            this._checkMarks()
        },

        _updateTiling( dt )
        {
            const lines = this._lines
            const winH = this.$root.$children[0].windowSize[1]
            // const scrollY = this._scrollY
            const dir = this._scrollDown

            const powerMin = 0.001
            const powerMax = 0.06   // 0.06 * 1000 / 60 --> 1
            const introDuration = 6000
            // const time = this._time + dt
            // this._time = time



            if (!this._startTime)
                this._startTime = Date.now()

            const introTime = Date.now() - this._startTime
            let introMoveY = 0
            if (introTime < 5000)
            {
                introMoveY = easeOutCirc(introTime, -5000, 5000, 5000)
            }



            for(let i = 0, l = lines.length; i < l; i++)
            {
                const line = lines[i]
                const tiling = line.tiling


                // Position
                // const globalNext = line.y - tiling.next


                // Power by y position
                // let power = dir ? (Math.abs(globalNext - winH) / winH) : Math.abs(globalNext / winH)
                // power = Math.min(Math.max(power, 0), 1)
                // power = (powerMax - powerMin) * (power) + powerMin


                // Position
                // let current = tiling.current
                // current += (tiling.next - current) * power * dt

                let current = tiling.next + introMoveY


                // Introduction
                // if (time < introDuration)
                // {
                //     const duration = introDuration - 0.5 * introDuration * (i - lines.length) / lines.length
                //     current += easeOutExpo(time, -winH, winH, duration)
                // }

                // current = Math.round(current * 100) / 100



                const globalPos = line.y - current



                if (globalPos < winH && globalPos + line.h > 0)
                {
                    if (line.hide)
                    {
                        line.elmt.classList.add('is-in')
                        line.elmt.classList.remove('is-out')
                        line.hide = false
                    }

                    line.elmt.style.transform = `translateY(${-current.toFixed(1)}px) translateZ(0)`
                }
                else
                {
                    if (!line.hide)
                    {
                        line.elmt.classList.add('is-out')
                        line.elmt.classList.remove('is-in')
                        line.hide = true
                    }
                }

                tiling.current = current
            }
        },

        _introLineTiling()
        {
            const winH = this.$root.$children[0].windowSize[1]
            const lines = this._lines

            for(let i = 0, l = lines.length; i < l; i++)
            {
                const line = lines[i]
                const tiling = line.tiling
                tiling.next = -winH
            }
        },

        _setLineTiling( scrollY = this._scrollY )
        {
            const lines = this._lines
            for(let i = 0, l = lines.length; i < l; i++)
            {
                const line = lines[i]
                const tiling = line.tiling

                tiling.next = scrollY
            }
        },

        _onUnscroll()
        {
            this.isScrolling = false
            // this.$el.classList.add('is-unscroll')
            // this.$el.classList.remove('is-scroll')
        },



        /*
                ┌─────────────────────────────────────────────
                │
                │       INIT TEXT
                │
                └─────────────────────────────────────────────
        */

        _resetTileClass()
        {
            const saveScroll = [
                0,
                window.scrollY || document.documentElement.scrollTop
            ]
            window.scrollTo(0, 0)

            const lines = this._lines
            this.textWidth = 'none'
            let i = lines.length
            while (--i > -1)
            {
                const line = lines[i].elmt
                line.style.top = ''
                line.style.left = ''
                line.style.transform = ''
                line.classList.remove('u-absolute')
                line.classList.add('is-in')
            }

            return saveScroll
        },


        // INIT CONTENT DATAS (SIZE, ANIMATIONS)
        _initLinesClass()
        {
            const scrollY = (window.scrollY || document.documentElement.scrollTop)

            const lineDataList = this._lineListElmt.map((elmt) => {

                const bounds = getBounds(elmt)
                const w = elmt.children[0].getBoundingClientRect().width
                const data = {
                    elmt,
                    y: bounds.y - scrollY,
                    h: bounds.h,
                    hide: false,
                    tiling: {
                        current: bounds.y - scrollY,
                        next: bounds.y - scrollY
                    }
                }

                return data
            })

            return lineDataList
        },


        // MOVE LINES TO ABSOLUTE POSITION
        _initTilePos(lines)
        {
            const firstLineY = lines[0].y
            let i = lines.length
            let max = 0
            while (--i > -1)
            {
                const line = lines[i]
                const elmt = line.elmt
                elmt.style.top = (line.y - firstLineY) + 'px'
                elmt.style.left = '0'
                elmt.classList.add('u-absolute')
                max = Math.max(elmt.offsetWidth, max)
            }

            this.textWidth = max + 'px'
            this.margLeft = this._getTextMarg( max )
        },

        _initText( reset = false )
        {
            // if reset, save scroll, change it and reset class
            let saveScroll = (reset) ? this._resetTileClass() : null


            // get DOM elements
            const textElmt = this.$el.querySelector('#home-text-content')
            const lines = this._initLinesClass()


            // modify DOM
            const bounds = textElmt.getBoundingClientRect()
            const textH = bounds.height + 2 * bounds.top
            this.$root.$children[0].setHeight(textH)
            this._initTilePos(lines)


            // if scroll saved, reload last scroll
            if (saveScroll)
            {
                saveScroll[1] = Math.min(saveScroll[1], textH - this.$root.$children[0].windowSize[1])
                window.scrollTo(...saveScroll)
            }

            this._lines = lines


            // hide tiles out of the screen
            this._onUnscroll()
            if (this.fakeScroll)
            {
                this._setLineTiling()
            }
        },

        _getText()
        {
            const tagInLine = '<div class="c-text-line is-in u-cariage-return"><span class="u-inline-block u-force-inline">'
            const tagOutLine = '<span></div>'
            const tagOutHide = '</span></span>'
            const markIn = '<span class="js-home-mark-in"></span>'
            const markOut = '<span class="js-home-mark-out"></span>'
            const foot = '<a href="/the-book" onclick="return _hackGoToHome();" class="c-home-text-bottom"><span class="c-home-text-bottom__content"><span class="c-home-text-bar"></span> <small class="c-home-text--small">discover</small> the book</span></a>'


            window._hackGoToHome = () => {
                this.$router.push('/the-book')
                return false
            }

            const str = tagInLine
                         + (TEXT + '\n\n\n\n\n')
                         .split(' ') .join('&nbsp;')
                         .split('[m]') .join(markIn)
                         .split('[/m]').join(markOut)
                         .split('\n')
                         .concat([foot])
                         .join(tagOutLine + tagInLine)
                         .split('[/h]').join(tagOutHide)
                         + tagOutLine


            // Add random delay
            const arr = str.split('[h]')
            let text = arr.shift()
            for(const part of arr)
            {
                const rand = this._rand(0, 0.5)
                const randText = rand.toFixed(2)
                const randLine = (rand + 0.5).toFixed(2)
                text += `<span class="c-text-appears"><span class="c-text-appears--line" style="transition-delay:${randText}s"></span><span class="c-text-appears--text" style="transition-delay:${randLine}s">${part}`
            }

            return text
        },



        /*
                ┌─────────────────────────────────────────────
                │
                │       HELPERS
                │
                └─────────────────────────────────────────────
        */

        _rand( min, max )
        {
            return Math.random() * (max - min) + min
        },

        _getTextWidth()
        {
            this.textWidth = 'none'

            const list = this._lineChildListElmt

            let i = list.length
            let max = 0
            while (--i > -1)
            {
                const line = list[i]
                max = Math.max(line.offsetWidth, max)
            }

            return max
        },

        _getTextMarg( width )
        {
            return (this.$root.$children[0].windowSize[0] - width) / 2
        }
    },
}
